import React, { Fragment } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import eccd from "../img/eccd.png";
import { useHistory, useLocation } from "react-router-dom";

const styles = {
  selected: {
    color: "#44B8A8",
    // borderColor: "#44B8A8",
    border: "#44B8A8 solid 5px",
    borderRadius: "10px",
    width: "200px",
    fontSize: 16,
    fontweight: "lighter",
    paddingTop: 10,
    paddingBottom: 10,
    margin: "5px auto",
  },
  not_selected: {
    background: "#44B8A8",
    color: "white",
    borderRadius: "8px",
    width: "200px",
    margin: "9px auto",
    fontSize: 16,
    paddingTop: 10,
    paddingBottom: 10,
    // padding: "4px"
  },
};
export const NavigationBar: React.FC = () => {
  var history = useHistory();
  var location = useLocation();
  return (
    <Fragment>
      <Grid container direction="column">
        <div style={{ width: 200, margin: "auto" }}>
          <h3 style={{ width: 200, margin: "auto", color: "#44B8A8" }}>
            Green City Performance Tracker
          </h3>
          <h5 style={{ marginBottom: 0 }}>Organisation: </h5>
          <h5 style={{ marginTop: 0, fontWeight: "normal" }}>
            Southampton City Council
          </h5>
        </div>

        <Button
          style={
            location.pathname === "/home"
              ? styles.selected
              : styles.not_selected
          }
          onClick={() => {
            history.push("/home");
          }}
        >
          Assessment questions
        </Button>
        <Button
          style={
            location.pathname === "/guide"
              ? styles.selected
              : styles.not_selected
          }
          onClick={() => {
            history.push("/guide");
          }}
        >
          Guide
        </Button>
        <Button style={styles.not_selected}>Map</Button>
        <Button
          style={
            location.pathname === "/dashboard"
              ? styles.selected
              : styles.not_selected
          }
          onClick={() => {
            history.push("/dashboard");
          }}
        >
          Dashboard
        </Button>
        <Button
          style={
            location.pathname === "/benchmarking"
              ? styles.selected
              : styles.not_selected
          }
          onClick={() => {
            history.push("/benchmarking");
          }}
        >
          Benchmarking
        </Button>
        <Button
          style={
            location.pathname === "/reporting"
              ? styles.selected
              : styles.not_selected
          }
          onClick={() => {
            history.push("/reporting");
          }}
        >
          Reporting
        </Button>
        <Button style={styles.not_selected}>Feedback / comment</Button>
      </Grid>
      <div style={{ width: 200, margin: " 30px auto" }}>
        <h5 style={{ marginTop: 0, fontWeight: "normal" }}>
          Developed by the{" "}
        </h5>
        <img width="100%" src={eccd} />
      </div>
    </Fragment>
  );
};
